module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/335.ba5cffc5.png";